import { Button, Modal } from 'antd';
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';
import apiParticipantes from '../../api/Participantes/api-participantes';
import { useEncrypt } from '../../hooks/useEncrypt';

interface IProps {
    visualizar: boolean;
    setVisualizar: any;
    onAceptar: any;
    onCategorias?: any;
    titlle?: string;
    description: string;
    subdescription?: string;
}

const ModalWarning: FC<IProps> = ({ visualizar, setVisualizar, onAceptar, onCategorias, titlle = "Estamos procesando la solicitud", description, subdescription }) => {
    const navigate = useNavigate();
    const { decrypt } = useEncrypt();

    const redirectUsuarios = async () => {
        try {
            const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));
            await apiParticipantes.eliminarPostulacion(id_postulacion);
            if (onCategorias) return navigate('/usuario');
        } catch(error) { console.error(error); }
    }

    return (
        <Modal
            // title=""
            visible={visualizar}
            onCancel={onAceptar}
            maskStyle={{
                background: "rgba(149, 118, 70, 1)",
            }}
            width={662}
            footer={[
                <div key="B_Aceptar_modalwarning" className="text-center p-3">
                    <Button onClick={!onCategorias ? onAceptar : redirectUsuarios } className="button-azul-radius" style={{ marginTop: 0, marginBottom: 0 }} htmlType="submit">
                        Aceptar
                    </Button>
                </div>
            ]}
            cancelButtonProps={{ style: { display: "none" } }}
        >
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 font-size-24px font-color-F28C02 font-family-Montserrat-SemiBold justify-content-center">
                        {titlle}
                    </div>
                    <div className="text-center col-12 font-family-Montserrat-Regular font-size-14px justify-content-center font-color-000000 mt-2">
                        {description}
                    </div>
                    <div className="text-center fw-bold col-12 font-family-Montserrat-bold font-size-14px justify-content-center mt-1 font-color-000000">
                        {subdescription}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalWarning